export const formatPrice = (price: any) => {
	if (!price && price !== 0) return '-'
	return Number(price).toFixed(2)
}

export const formatPriceCurrencyPrepend = (price: any, currency: string = 'PLN') =>
	// PLN 12.00
	`${currency} ${formatPrice(price)}`

export const formatPriceCurrencyAppend = (price: any, currency: string = 'zł') =>
	// 12.00 zł
	`${formatPrice(price)} ${currency}`

export const dividePrice = (price: any) => (price || price === 0 ? price / 100 : null)

export const multiplyPrice = (price: any) => (price || price === 0 ? price * 100 : null)

export const formatPriceGlobal = (price: number, currency: string = 'zł') => {
	const formattedPrice = (price / 100).toFixed(2)
	return `${formattedPrice} ${currency}`
}

type PriceValue = string | number | null

export const PriceToShow = (price: PriceValue, digits: number = 2): string | null => {
	if (price === 0) return '0.00'

	if (!price) return null

	const formatted = Number(price) / 100

	return formatted.toFixed(digits)
}

export const PriceToShowNumber = (price: PriceValue): number | null => {
	if (!price) return null

	return Number(price) / 100
}

export const PriceToPayload = (price: PriceValue) => {
	if (!price) return null

	return Number.isNaN(Number(price)) ? null : Number((Number(price) * 100).toFixed(0))
}

export const PriceToCents = (price: string | number | null) => {
	if (!price) return null

	return Number.isNaN(Number(price)) ? null : Number((Number(price) * 100).toFixed(0))
}
